import { render } from "./TodaysShipmentsChart.vue?vue&type=template&id=045f7f52&ts=true"
import script from "./TodaysShipmentsChart.vue?vue&type=script&lang=ts"
export * from "./TodaysShipmentsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__